<template>
    <div class="add-house">
        <alart-msg :display="alart.state" styleType="error" @alartStatus="closeAlart()">
            <span class="title" slot="title">{{alart.msg}}</span>
        </alart-msg>
        <add-nick-name :noClose="true"></add-nick-name>
        <add-equips @setEquips="setNewEquips($event)"></add-equips>
        <div class="tool-bar-mask"></div>
        <div class="add-house-head">
            <h1 class="page-title">刊登廣告</h1>
            <div class="btn-group">
                <button class="border-button save" @click="saveHouseNoReview">僅儲存</button>
                <button class="default-button publish" @click="saveHouse">儲存並上架</button>
            </div>
        </div>
        <div class="add-house-description">
            <h1 class="unit-title">
                房源說明
                <span class="title-description">
                    <img src="@/assets/img/icon/info_gray.svg" alt="">
                    僅接受 jpg、png，每張不得超過 5ＭＢ，建議尺寸 300 x 400 px，內容圖限上傳十張
                </span>
            </h1>
            <div class="house-name">
                <label class="add-label" for="">廣告標題</label>
                <div class="input-error-group">
                    <input :class="{error: error.nameErr}" type="text" v-model="insertHouse.name" placeholder="6-20 個字">
                    <span v-show="error.nameErr" class="error">{{error.nameErr}}</span>
                </div>
            </div>
            <div class="house-rent">
                <label class="add-label" for="">房屋租金</label>
                <div class="input-error-group">
                    <input :class="{error: error.rentMonthlyErr}" type="text" v-model="insertHouse.rentMonthly" placeholder="請輸入金額">
                    <span v-show="error.rentMonthlyErr" class="error">{{error.rentMonthlyErr}}</span>
                </div>
            </div>
            <div class="house-intro">
                <label class="add-label" for="">房源介紹</label>
                <div class="input-error-group">
                    <div class="intro-container">
                        <pre class="pre"></pre>
                        <textarea id="add-description" @keyup="autoGrow()" :class="{error: error.desErr}" v-model="insertHouse.description" placeholder="50-2000 個字" ></textarea>
                        <span class="des-count"><span class="count">{{insertHouse.description.length}}</span>/2000</span>
                    </div>
                    <span v-show="error.desErr" class="error">{{error.desErr}}</span>
                </div>
            </div>
            <upload-img :imgError="error.imgErr" :imgCoverError="error.imgCoverErr"></upload-img>
        </div>
        <div class="add-house-description">
            <h1 class="unit-title">
                上傳影片
                <span class="title-description">
                    <img src="@/assets/img/icon/info_gray.svg" alt="">
                    上傳案件影片讓房客找房更方便，增加成交機率，影片時間建議不要超過兩分鐘
                </span>
            </h1>
            <upload-video></upload-video> 
        </div>
        <div class="add-house-type">
            <h1 class="unit-title">房源類型</h1>
            <div class="section-one">
                <div class="lease-type">
                    <label class="add-label" for="">出租類型</label>
                    <rent-select :class="{error: error.houseTypeErr}" refName="houseType" selectMsg="請選擇出租類型" @getId="getSelectId"  bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li v-for="(house, index) in houseType" :key="index" :data-id="house.houseTypeCode">
                                {{house.itemName}}
                            </li>
                        </ul>
                    </rent-select>
                    <span v-show="error.houseTypeErr" class="error">{{error.houseTypeErr}}</span>
                </div>
                
               <div v-if="insertHouse.houseType == 1" class="house-pattern">
                    <label class="add-label" for="">房源格局</label>
                    <div class="house-pattern-wrap">
                        <rent-select refName="bedroom" selectMsg="房" @getId="getSelectId" bgColor="#fff" :setDefault="housePattern">
                            <ul>
                                <li v-for="n in 11" :key="n" :data-id="n-1">
                                    {{n-1}} 房
                                </li>
                            </ul>
                        </rent-select>
                        <rent-select refName="sharedRoom" selectMsg="廳" @getId="getSelectId" bgColor="#fff" :setDefault="housePattern">
                            <ul>
                                <li v-for="n in 11" :key="n-1" :data-id="n-1">
                                    {{n-1}} 廳
                                </li>
                            </ul>
                        </rent-select>
                        <rent-select refName="bathroom" selectMsg="衛浴" @getId="getSelectId" bgColor="#fff" :setDefault="housePattern">
                            <ul>
                                <li v-for="n in 11" :key="n-1" :data-id="n-1">
                                    {{n-1}} 衛浴
                                </li>
                            </ul>
                        </rent-select>
                        <rent-select refName="balcony" selectMsg="陽台" @getId="getSelectId" bgColor="#fff" :setDefault="housePattern">
                            <ul>
                                <li v-for="n in 11" :key="n-1" :data-id="n-1">
                                    {{n-1}} 陽台
                                </li>
                            </ul>
                        </rent-select>
                    </div>
                </div>
                <div v-else class="house-pattern">
                    <label class="add-label" for="">房源格局</label>
                    <div class="house-pattern-wrap2">
                        <rent-select refName="hasBalcony" selectMsg="陽台" @getId="getSelectId" bgColor="#fff" :setDefault="roomPattern">
                            <ul>
                                <li data-id="1">
                                    有陽台
                                </li>
                                <li data-id="0">
                                    無陽台
                                </li>
                            </ul>
                        </rent-select>
                        <rent-select refName="hasDuplex" selectMsg="閣樓" @getId="getSelectId" bgColor="#fff" :setDefault="roomPattern">
                            <ul>
                                <li data-id="1">
                                    有閣樓
                                </li>
                                <li data-id="0">
                                    無閣樓
                                </li>
                            </ul>
                        </rent-select>
                    </div>
                </div>
                <div class="house-type">
                    <label class="add-label" for="">房屋類型</label>
                    <rent-select :class="{error: error.buildingTypeErr}" refName="buildingType" selectMsg="請選擇房屋類型" @getId="getSelectId" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li v-for="(build, index) in buildingType" :key="index" :data-id="build.buildingTypeCode">
                                {{build.itemName}}
                            </li>
                        </ul>
                    </rent-select>
                    <span v-show="error.buildingTypeErr" class="error">{{error.buildingTypeErr}}</span>
                </div>
                <div class="house-size">
                    <label class="add-label" for="">房源坪數</label>
                    <div class="input-error-group">
                        <input :class="{error: error.sizeErr}" type="number" v-model="insertHouse.size" placeholder="輸入房源坪數">
                        <span v-show="error.sizeErr" class="error">{{error.sizeErr}}</span>
                    </div>
                    
                </div>
                <div class="house-special">
                    <label class="add-label" for="">特殊樓層</label>
                    <rent-select :class="{error: error.specialTypeErr}" refName="specialType" selectMsg="請選擇特殊樓層" @getId="getSelectId" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li v-for="(special, index) in specialType" :key="index" :data-id="special.specialTypeCode">
                                {{special.itemName}}
                            </li>
                        </ul>
                    </rent-select>
                    <span v-show="error.specialTypeErr" class="error">{{error.specialTypeErr}}</span>
                </div>
                <div class="house-total-floor">
                    <label class="add-label" for="">房源總樓層</label>
                    <div class="input-error-group">
                            <input :class="{error: error.totalFloorErr}" type="text" v-model="insertHouse.totalFloor" placeholder="輸入總樓層">
                            <span v-show="error.totalFloorErr" class="error">{{error.totalFloorErr}}</span>
                    </div>
                </div>
                <div class="shortest-period">
                    <label class="add-label" for="">最短租期</label>
                    <rent-select :class="{error: error.shortestPeriodErr}" refName="shortestPeriod" selectMsg="請選擇最短租期" @getId="getSelectId" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li v-for="(date, index) in houseConfig.shortestPeriod" :key="index" :data-id="date.code">
                                {{date.name}}
                            </li>
                        </ul>
                    </rent-select>
                    <span v-show="error.shortestPeriodErr" class="error">{{error.shortestPeriodErr}}</span>
                </div>
                <div class="is-with-landlord">
                    <label class="add-label" for="">與屋主同住</label>
                    <rent-select :class="{error: error.isWithLandlordErr}" refName="isWithLandlord" selectMsg="請選擇是否與屋主同住" @getId="getSelectId" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li data-id="1">
                                是
                            </li>
                            <li data-id="0">
                                否
                            </li>
                        </ul>
                    </rent-select>
                    <span v-show="error.isWithLandlordErr" class="error">{{error.isWithLandlordErr}}</span>
                </div>
                <div class="house-special">
                    <label class="add-label" for="">繳款方式</label>
                    <rent-select :class="{error: error.payByRentPayDayErr}" refName="payway" selectMsg="請選擇繳款方式" @getId="getSelectId" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li data-id="contract">
                                {{getPayWayWord('contract')}}
                            </li>
                            <li data-id="date">
                                {{getPayWayWord('date')}}
                            </li>
                        </ul>
                    </rent-select>
                    <span v-show="error.payByRentPayDayErr" class="error">{{error.payByRentPayDayErr}}</span>
                    <span v-if="insertHouse.payByRentPayDay" v-show="error.rentPayDayErr" class="error" style="position: absolute;right: -140px;top: 2px;">{{error.rentPayDayErr}}</span>
                    <rent-select v-if="insertHouse.payByRentPayDay" class="select-date select-scroll" :class="{error: error.rentPayDayErr}" refName="date" selectMsg="請選擇日期" @getId="getSelectId" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li v-for="n in 29" :key="n" :data-id="n">
                                每月 {{n}} 號
                            </li>
                            <li :data-id="-1">
                                每月最後一天
                            </li>
                        </ul>
                    </rent-select>
                </div>
                <div class="move-in-date">
                    <label class="add-label" for="">最快起租日</label>
                     <div class="input-error-group">
                        <date-picker v-model="insertHouse.moveInDate" :class="{'active': insertHouse.moveInDate != '', errorr: error.moveInDateErr}" placeholder="請選擇日期" :disabled-date="notBeforeToday" value-type="format" format="YYYY-MM-DD"></date-picker>
                        <span v-show="error.moveInDateErr" class="error">{{error.moveInDateErr}}</span>
                    </div>
                </div>
            </div>
            <div class="section-two">
                <div class="house-address">
                    <label class="add-label" for="">房源地址</label>
                    <div class="hide-num">
                        <rent-checkbox v-model="insertHouse.isNumberHidden" val="1" checkboxMsg="隱藏門牌" tickColor="black" bgColor="#fff" borderColor="#cacfcd" :isPropChecked="false" ></rent-checkbox>
                    </div>
                    <span v-show="error.floorErr" class="error">{{error.floorErr}}</span>
                    <div class="house-address-wrap">
                        <rent-select :class="{error: error.cityCidErr}" class="select-scroll" refName="county" :selectMsg="address.county.msg" @getId="getSelectId" bgColor="#fff" :setDefault="isDefault">
                            <ul>
                                <li v-for="(county, index) in counties" :key="index" :data-id="index">
                                    {{county}}
                                </li>
                            </ul>
                        </rent-select>
                        <rent-select :class="{error: error.districtCidErr}" class="select-scroll" refName="district" :selectMsg="address.district.msg" @getId="getSelectId" bgColor="#fff" :setDefault="address.district.state">
                            <ul>
                                <li v-for="(district, index) in districts" :key="index" :data-id="district.districtCid">
                                    {{district.districtName}}
                                </li>
                            </ul>
                        </rent-select>
                        <rent-select :class="{error: error.roadStreetCidErr}" class="select-scroll select-road" refName="road" :selectMsg="address.road.msg" @getId="getSelectId" bgColor="#fff" :setDefault="address.road.state">
                            <ul>
                                <div class="road-filter">
                                    <img class="search" src="@/assets/img/icon/search_gray.svg" alt="">
                                    <input v-model="selectRoad" placeholder="搜尋路段" type="text">
                                </div>
                                <li v-for="(road, index) in filterRoad" :key="index" :data-id="road.roadStreetCid">
                                    {{road.roadStreetName}}
                                </li>
                            </ul>
                        </rent-select>
                        <div class="lane">
                            <input type="text" v-model="insertHouse.lane" placeholder="輸入幾巷">
                            <span>巷</span>
                        </div>
                        <div class="alley">
                            <input type="text" v-model="insertHouse.alley" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="輸入幾弄">
                            <span>弄</span>
                        </div>
                        <div class="number">
                            <input :class="{error: error.numErr}" type="text" v-model="insertHouse.number" placeholder="輸入幾號">
                            <span>號之</span>
                        </div>
                        <div class="number">
                            <input type="text"  v-model="insertHouse.dash" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="輸入之幾">
                        </div>
                        <div class="floor">
                            <input :class="{error: error.floorErr}" type="text" v-model="insertHouse.floor" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="輸入樓層">
                            <span>樓之</span>
                        </div>
                        <div class="room">
                            <input type="text" v-model="insertHouse.room">
                        </div>
                        
                    </div>
                </div>
                <div class="rent-include">
                    <label class="button-font input-label">
                        <div class="title">
                            提供設備
                        </div>
                    </label>
                    <div class="wrap">
                        <div class="house-equips h-align" :class="{'odd': index%2 === 0}" v-for="(equip, index) in houseEquips" :key="'houseEquips'+index">
                            <checkbox v-model="insertHouse.equipmentList[index].check" :msg="equip.itemName" :val="equip.equipCode" :isPropChecked="insertHouse.equipmentList[index].check"></checkbox>
                            <div class="input-arear">
                                <span class="quantifier">個</span>
                                <input :class="{'error': error.equipment[index]}"  type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertHouse.equipmentList[index].count" placeholder="請輸入數量">
                            </div>
                        </div>
                        <div class="house-equips new-equips" @click="$store.dispatch('setModalStatus', {state: true, type: 'bizAddEquips'})">
                            新增設備
                        </div>
                        <!-- <house-checkbox v-model="houseEquip" v-for="(equip, index) in houseEquips" :key="'houseEquips'+index"  :val="equip.equipCode" :checkboxMsg="equip.itemName" :isPropChecked="false" ></house-checkbox> -->
                    </div>
                </div>
                <div class="rent-include">
                    <label class="add-label" for="">租金包含</label>
                    <div class="wrap">
                        <house-checkbox v-model="houseInclude" v-for="(include, index) in houseRentInclude" :key="index"  :val="include.rentCode" :checkboxMsg="include.itemName" :isPropChecked="false" ></house-checkbox>
                    </div>
                </div>
                <bill-charge loginType="LANDLORD"  @error="setBillChargeError" :includeList="insertHouse.rentIncludeList" v-model="insertHouse.billChargeMode"></bill-charge>
                <!-- <div class="equipment">
                    <label class="add-label" for="">提供設備</label>
                    <div class="wrap">
                        <house-checkbox v-model="houseEquip" v-for="(equip, index) in houseEquips" :key="index"  :val="equip.equipCode" :checkboxMsg="equip.itemName" :isPropChecked="false" ></house-checkbox>
                    </div>
                </div> -->
                <div class="rules">
                    <label class="add-label" for="">特色標籤 ( 最多選擇 6 個 )</label>
                    <div class="wrap">
                        <house-checkbox v-model="houseFeature" v-for="(feature, index) in houseFeatures" :key="index"  :val="feature.featureCode" :checkboxMsg="feature.itemName" :isPropChecked="false" ></house-checkbox>
                    </div>
                </div>
                <div class="rules" v-if="rulesInContract.length">
                    <label class="add-label" for="">使用規範 ( 會寫入合約內 )</label>
                    <div class="wrap">
                        <span v-for="(item, index) in rulesInContract" :key="index">
                            {{item}}{{rulesInContract.length-1 === index?'':'、'}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="add-contract-version">
            <div class="title-group h-align">
                <h1 class="unit-title">
                    合約版本
                </h1>
                <div class="group">
                    <button class="refresh" v-if="status.isShowReloadBtn" @click="status.reloadContractVertion++, status.isShowReloadBtn=false">
                        <img src="@/assets/img/icon/refresh.svg" alt="">
                        更新合約版本
                    </button>
                </div>
            </div>
            <div>
                <choose-contract-version v-model="insertHouse.contractVersionId" @edit="status.isShowReloadBtn=true" :reload="status.reloadContractVertion"></choose-contract-version>
            </div>
        </div>
        <!-- <div class="add-house-policy">
            <h1 class="unit-title">自訂合約條款 ( 電子合約內容 )</h1>
            <div class="house-policy">
                <div class="group">
                    <div class="edit" @click="modalStatus.globalPolocy = true, $analytics.logEvent('新增及編輯政策', { screen_name: '新增及編輯政策'})">
                        <img src="../../../../../assets/img/icon/edit_gray.svg" alt="">
                        編輯政策
                    </div>
                    <div class="view-default">
                        <router-link :to="{ name: 'defaultpolicy'}" target="_blank">
                            <img src="../../../../../assets/img/icon/view_gray.svg" alt="">
                            預設條款
                        </router-link>
                    </div>
                </div>
                <policy-checkbox v-model="housePolicyComputed" v-for="(housePolicy, index) in housePolicies" :key="index" val="1" :policyId="housePolicy.policySettingCid" :checkboxMsg="housePolicy.policySettingContent" :isPropChecked="false" ></policy-checkbox>
            </div>
            <modal class="global-policy" :display="modalStatus.globalPolocy" @modalStatus="modalStatus.globalPolocy = false, getHouseDefault()" >
                <h1>編輯政策</h1>
                <new-policy class="com-setting-div" :type="1" mainTitle="自訂合約條款"></new-policy>
            </modal>
        </div> -->
    </div>
</template>
<script>
import RentSelect from '@/components/widge/RentSelect.vue';
import DatePicker from 'vue2-datepicker';
import RentCheckbox from '@/components/widge/RentCheckbox.vue';
import HouseCheckbox from '@/components/widge/HouseCheckbox.vue';
import PolicyCheckbox from '@/components/widge/PolicyCheckbox.vue';
import uploadImg from '@/components/landlord/houseStatus/houseManagement/addHouse/uploadImg.vue';
import NewPolicy from '@/components/widge/NewPolicy.vue';
import Modal from '@/components/widge/Modal.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import addNickName from '@/components/widge/addNickName.vue';
import Checkbox from '@/components/bussiness/widges/input/checkbox.vue';
import addEquips from '@/components/bussiness/widges/modals/addEquips.vue';
import uploadVideo from '@/components/landlord/houseStatus/houseManagement/addHouse/uploadVideo.vue';
import billCharge from '@/components/bussiness/mgtCategory/houseMgt/addHouse/billCharge.vue';
import chooseContractVersion from '@/components/landlord/houseStatus/houseManagement/addHouse/chooseContractVersion.vue';

import { mapGetters } from 'vuex'

const today = new Date();
today.setHours(0, 0, 0, 0);

export default {
    data () {
        return {
            insertHouse: {
                "name": '',
                "cityCid": null,
                "districtCid": null,
                "roadStreetCid": null,
                "lane": '',
                "alley": '',
                "floor": '',
                "number": null,
                "dash": '',
                "room": '',
                "size": '',
                "houseType": null,
                "buildingType": null,
                "specialType": null,
                "rentMonthly": '',
                "moveInDate": '',
                "shortestPeriod": null,
                "isNumberHidden": false,
                "totalFloor": '',
                "isWithLandlord": null,
                "description": '',
                "equipmentList": [],
                "rentIncludeList": [],
                "ruleList": [],
                "rentPayDay": null,
                "payByRentPayDay": null,
                "billChargeMode": null,
                "contractVersionId": null,
                "housePatternDto": {
                    "bedroom": 0,
                    "sharedRoom": 0,
                    "bathroom": 0,
                    "balcony": 0
                },
                "roomPatternDto": {
                    "hasBalcony": false,
                    "hasDuplex": false
                },
                "editCaseHousePolicyDto": {
                    "policySettingType": 1,
                    "usePolicyDtoList": []
                },
                "editCaseDepositPolicyDto": {
                    "policySettingType": 2,
                    "usePolicyDtoList": []
                }
            },
            isDefault: false,
            address: {
                county: {
                    state: false,
                    msg: '縣市'
                },
                district: {
                    state: false,
                    msg: '區域'
                },
                road: {
                    state: false,
                    msg: '請選擇路名'
                }
            },
            housePattern: false,
            roomPattern: false,
            error: {
                totalFloorErr: '',
                rentMonthlyErr: '',
                sizeErr: '',
                nameErr: '',
                desErr: '',
                numErr: '',
                floorErr: '',
                moveInDateErr: '',
                cityCidErr: '',
                districtCidErr: '',
                roadStreetCidErr: '',
                houseTypeErr: '',
                buildingTypeErr: '',
                specialTypeErr: '',
                shortestPeriodErr: '',
                isWithLandlordErr: '',
                imgErr: false,
                imgCoverErr: false,
                rentPayDayErr: '',
                payByRentPayDayErr: '',
                equipment: [],
                billCharge: ''

            },
            modalStatus:{
                globalPolocy: false
            },
            // alart: {
            //     fail: false
            // },
            selectRoad: null,
            featureListCount: 0,
            status: {
                isShowReloadBtn: false,
                reloadContractVertion: 0
            },
        }
    },
    mounted () {
        this.$store.dispatch('getHouseDefault')  
        this.$store.dispatch('getHouseConfig')
        this.isNeedNickName()
        this.$analytics.logEvent('刊登廣告', { screen_name: '刊登廣告'})
    },
    watch: {
        insertHouse: {
            handler: function (newValue, oldValue) {
                let numerical = /^[0-9]*$/,
                    decimalNum = /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/
                // console.log(newValue.description)
                // console.log(newValue.description.length)
                // 總樓層
                if(newValue.totalFloor){
                    if( numerical.test(newValue.totalFloor) ){
                        this.error.totalFloorErr = ''
                    }else{
                        this.error.totalFloorErr = '請輸入數字'
                    }
                }
                
                // 房租
                if(newValue.rentMonthly){
                    if( numerical.test(newValue.rentMonthly) ){
                        this.error.rentMonthlyErr = ''
                    }else{
                        this.error.rentMonthlyErr = '請輸入數字'
                    }
                }
                // 坪數
                if(newValue.size){
                    var decimal = /^[0-9]+(\.[0-9]?)?$/;
                    if(decimal.test(newValue.size)){
                        this.error.sizeErr = ''
                    }else{
                        this.error.sizeErr = '請輸入小數1位內'
                    }
                }
                if(newValue.name){
                    if(newValue.name.length < 6 ){
                        this.error.nameErr = '廣告標題需滿6個字'
                    }else if(newValue.name.length > 20){
                        this.error.nameErr = '廣告標題20字以內'
                    }else{
                        this.error.nameErr = ''
                    }
                }
                if(newValue.description.length > 2000){
                    this.error.desErr = '字數限制2000以內'
                }else if(newValue.description){
                    this.autoGrow()
                    this.error.desErr = ''
                } 
                if(newValue.houseType){
                    this.error.houseTypeErr = ''
                }
                if(newValue.buildingType){
                    this.error.buildingTypeErr = ''
                }
                if(newValue.specialType != null){
                    this.error.specialTypeErr = ''
                }
                if(newValue.cityCid){
                    this.error.cityCidErr = ''
                }
                if(newValue.districtCid){
                    this.error.districtCidErr = ''
                }
                if(newValue.roadStreetCid){
                    this.error.roadStreetCidErr = ''
                }
                if(newValue.number){
                    this.error.numErr = ''
                }
                if(newValue.floor){
                    this.error.floorErr = ''
                }
                if(newValue.moveInDate){
                    this.error.moveInDateErr = ''
                }
                if(newValue.shortestPeriod){
                    this.error.shortestPeriodErr = ''
                }
                if(newValue.isWithLandlord != null){
                    this.error.isWithLandlordErr = ''
                }
               if(newValue.payByRentPayDay != null){
                    this.error.payByRentPayDayErr = ''
                }
                if(newValue.payByRentPayDay === false || newValue.rentPayDay){
                    this.error.rentPayDayErr = ''
                }
                if(newValue.equipmentList.length){
                    newValue.equipmentList.forEach(item=>{
                        if(item.check){
                            if(item.count === null){
                                item.count = 1
                            }
                        }else{
                            item.count = null
                        }
                    })
                }
                this.$store.dispatch('setHouseList',newValue)
            },
            deep: true
        },
        houseRentInclude: {
            handler: function (val) {
                this.insertHouse.rentIncludeList = val
                for (let i = 0; i < val.length; i++) {
                    const element = val[i];
                    // console.log(element.itemName+element.check)
                    if(element.check){
                        this.removeBillCharge(element.itemName)
                    }
                }
            },
            immediate: true,
            deep: true
        },
        houseEquips: {
            handler: function (val) {
                this.insertHouse.equipmentList = val
            },
            immediate: true
        },
        houseRules: {
            handler: function (val) {
                this.insertHouse.ruleList = val
            },
            immediate: true
        },
        houseFeatures: {
            handler: function (val) {
                this.insertHouse.featureList = val
            },
            immediate: true
        }
    },
    methods: {
        setBillChargeError: function (value){
            this.error.billCharge = value
        },
        getSelectId: function (value) {
            // console.log(value)
            let targetId = parseInt(event.target.dataset.id)
            if( value.ref == 'houseType' ){
                this.insertHouse.houseType = targetId
                this.roomPattern = true
                this.housePattern = true
            }else if( value.ref == 'buildingType'){
                this.insertHouse.buildingType = targetId
            }else if ( value.ref == 'specialType' ){
                this.insertHouse.specialType = targetId
            }else if( value.ref == 'shortestPeriod' ){
                this.insertHouse.shortestPeriod = targetId
            }else if( value.ref == 'bedroom' ){
                this.roomPattern = false
                this.housePattern = false
                this.insertHouse.housePatternDto.bedroom = targetId
            }else if( value.ref == 'bathroom' ){
                this.roomPattern = false
                this.housePattern = false
                this.insertHouse.housePatternDto.bathroom = targetId
            }else if( value.ref == 'sharedRoom' ){
                this.roomPattern = false
                this.housePattern = false
                this.insertHouse.housePatternDto.sharedRoom = targetId
            }else if( value.ref == 'balcony' ){
                this.roomPattern = false
                this.housePattern = false
                this.insertHouse.housePatternDto.balcony = targetId
            }else if( value.ref == 'hasBalcony' ){
                this.roomPattern = false
                this.housePattern = false
                if( event.target.dataset.id == 1){
                    this.insertHouse.roomPatternDto.hasBalcony = true
                }else{
                    this.insertHouse.roomPatternDto.hasBalcony = false
                }
            }else if( value.ref == 'hasDuplex' ){
                this.roomPattern = false
                this.housePattern = false
                if( targetId == 1){
                    this.insertHouse.roomPatternDto.hasDuplex = true
                }else{
                    this.insertHouse.roomPatternDto.hasDuplex = false
                }
            }else if( value.ref == 'isWithLandlord' ){
                if( event.target.dataset.id == 1){
                    this.insertHouse.isWithLandlord = true
                }else{
                    this.insertHouse.isWithLandlord = false
                }
            }else if ( value.ref == 'county' ){
                //區域及縣市變為預設
                this.address.district.state = true
                this.address.road.state = true
                this.address.district.msg = '所有區域'
                this.address.road.msg = '所有路段'
                this.insertHouse.districtCid = null
                this.insertHouse.roadStreetCid = null

                this.insertHouse.cityCid = targetId+1
                this.$store.dispatch('getDistrict',(targetId+1))
            }else if ( value.ref == 'district' ){
                this.address.road.state = true
                this.address.road.msg = '所有路段'
                this.address.district.state = false

                this.insertHouse.districtCid = targetId
                this.$store.dispatch('getRoad',(targetId))
            }else if ( value.ref == 'road' ){
                this.address.road.state = false

                this.insertHouse.roadStreetCid = targetId
            }else if( value.ref == 'payway'){
                if(event.target.dataset.id === 'date'){
                    this.insertHouse.payByRentPayDay = true
                }else if(event.target.dataset.id === 'contract'){
                    this.insertHouse.payByRentPayDay = false
                }
            }else if( value.ref == 'date'){
                this.insertHouse.rentPayDay = targetId
            }
        },
        setNewEquips: function (value) {
            this.insertHouse.equipmentList.push({
                check: true,
                itemName: value.name,
                count: value.count?value.count:0,
                equipCode: 0
            })
        },
        saveHouse: function () {
            if(this.checkInput()){
                // this.insertHouse.alley = this.insertHouse.alley?this.insertHouse.alley:0
                // this.insertHouse.dash = this.insertHouse.dash?this.insertHouse.dash:0
                this.$analytics.logEvent('儲存並上架', { screen_name: '儲存並上架'})
                this.insertHouse.moveInDate = this.getFormatDate(this.insertHouse.moveInDate)
                this.$store.dispatch('setLoadingState', 1)
                this.$store.dispatch('saveHouse', this.insertHouse)
                .then(() => {
                    this.$router.push({ name: 'HouseManagementDefault', query: { success: '1' }})
                    this.$store.dispatch('setLoadingState', 0)
                })
            }
        },
        saveHouseNoReview: function () {
            if( this.noReviewCheckInput() ){
                this.$analytics.logEvent('僅儲存', { screen_name: '僅儲存'})
                this.insertHouse.moveInDate?this.getFormatDate(this.insertHouse.moveInDate):null
                this.$store.dispatch('setLoadingState', 1)
                this.$store.dispatch('saveHouseNoReview', this.insertHouse)
                .then(() => {
                    this.$router.push({ name: 'HouseManagementDefault', query: { success: '1' }})
                    this.$store.dispatch('setLoadingState', 0)
                })
            }
                
        },
        getHouseDefault: function () {
            this.$store.dispatch('getHouseDefault')
        },
        autoGrow: function (){
            let textarea = document.getElementById('add-description')
            let adjustedHeight=textarea.clientHeight;

            adjustedHeight=Math.max(textarea.scrollHeight,adjustedHeight);
            // if (adjustedHeight>textarea.clientHeight){
                textarea.style.height=adjustedHeight+'px';
            // }

        },
        isNeedNickName: function () {
            // console.log(this.userVerify)
            // console.log(this.userNickname)
            this.$store.dispatch('getUserStatus')
            .then( () => {
                if(!this.userVerify && !this.userNickname){
                    this.$analytics.logEvent('新增出租人姓名', { screen_name: '新增出租人姓名'})
                    this.$store.dispatch('setModalStatus', {state: true, type: 'addNickName'})
                }
            })
        },
        notBeforeToday(date) {
            return date < today;
        },
        noReviewCheckInput (){
            if(!this.insertHouse.name){
                this.error.nameErr = '房源名稱需滿6個字'
            }
            // if(this.insertHouse.billChargeMode.length){
            //     for (let i = 0; i < this.insertHouse.billChargeMode.length; i++) {
            //         const element = this.insertHouse.billChargeMode[i];
            //         if(element.type !=='PAY_BY_SELF' && !element.amount && !this.isInRentInclude(element.itemName)){
            //             this.$store.dispatch('setAlarmStatus', {status: true,title: `${element.itemName}不得為空值`,type: 'error'})
            //             this.error.billCharge = true
            //             return
            //         }
            //     }
            // }
            if(
                this.insertHouse.name.length > 5 &&
                this.insertHouse.name.length < 21 &&
                this.error.nameErr == '' 
                // !this.error.billCharge
            ){
                return true
            }else{
                this.$store.dispatch('setAlarmStatus', {status: true,title: '請確認所有必填欄位都已填寫完畢',type: 'error'})
                return false
            }
        },
        checkInput: function () {
            if(!this.hasImage){
                this.error.imgErr = true
            }else{
                this.error.imgErr = false
            }
            if(!this.hasCover){
                this.error.imgCoverErr = true
            }else{
                this.error.imgCoverErr = false
            }
            
            if(!this.insertHouse.name){
                this.error.nameErr = '房源名稱需滿6個字'
            }
            if(!this.insertHouse.rentMonthly){
                this.error.rentMonthlyErr = '請填寫租金'
            }

            if(!this.insertHouse.description){
                this.error.desErr = '請填寫房源描述'
            }

            if(!this.insertHouse.size){
                this.error.sizeErr = '請填寫坪數'
            }

            if(!this.insertHouse.totalFloor){
                this.error.totalFloorErr = '請填寫總樓層'
            }

            if(!this.insertHouse.number){
                this.error.numErr = '請填寫完整欄位'
            }

            if(!this.insertHouse.floor){
                this.error.floorErr = '請填寫完整欄位'
            }

            if(!this.insertHouse.moveInDate){
                this.error.moveInDateErr = '請填寫起租日'
            }
            
            if(!this.insertHouse.cityCid){
                this.error.cityCidErr = '請填寫完整欄位'
            }
            if(!this.insertHouse.districtCid){
                this.error.districtCidErr = '請填寫完整欄位'
            }
            if(!this.insertHouse.roadStreetCid){
                this.error.roadStreetCidErr = '請填寫完整欄位'
            }
            if(!this.insertHouse.houseType){
                this.error.houseTypeErr = '請選擇出租類型'
            }
            if(!this.insertHouse.buildingType){
                this.error.buildingTypeErr = '請選擇房屋類型'
            }
            if(this.insertHouse.specialType  == null){
                this.error.specialTypeErr = '請選擇特殊樓層'
            }
            if(!this.insertHouse.shortestPeriod){
                this.error.shortestPeriodErr = '請選擇最短租期'
            }
            if(this.insertHouse.isWithLandlord == null){
                this.error.isWithLandlordErr = '請選擇是否與屋主同住'
            }
            if(this.insertHouse.payByRentPayDay == null){
                this.error.payByRentPayDayErr = '請選擇繳款方式'
            }
            if(this.insertHouse.payByRentPayDay && this.insertHouse.rentPayDay == null){
                this.error.rentPayDayErr = '請選擇繳款日'
            }
            if(this.checkEquip.isError){
                this.$store.dispatch('setAlarmStatus', {status: true,title: `提供設備：${this.checkEquip.itemName}不得為空值`,type: 'error'})
                return
            }
            if(this.insertHouse.billChargeMode.length){
                for (let i = 0; i < this.insertHouse.billChargeMode.length; i++) {
                    const element = this.insertHouse.billChargeMode[i];
                    if(element.type !=='PAY_BY_SELF' && !element.amount && !this.isInRentInclude(element.itemName)){
                        this.$store.dispatch('setAlarmStatus', {status: true,title: `${element.itemName}不得為空值`,type: 'error'})
                        this.error.billCharge = true
                        return
                    }
                }
            }
            if(
                this.insertHouse.name &&
                this.insertHouse.rentMonthly &&
                this.insertHouse.description &&
                this.insertHouse.totalFloor &&
                this.insertHouse.number &&
                this.insertHouse.floor &&
                this.insertHouse.moveInDate &&
                this.insertHouse.districtCid &&
                this.insertHouse.roadStreetCid &&
                this.insertHouse.houseType &&
                this.insertHouse.buildingType &&
                this.insertHouse.cityCid &&
                this.insertHouse.isWithLandlord != null &&
                this.insertHouse.payByRentPayDay != null &&
                this.insertHouse.shortestPeriod &&
                this.insertHouse.specialType != null &&
                !this.checkEquip.isError &&
                this.hasImage &&
                this.hasCover &&
                !this.error.billCharge &&
                this.error.totalFloorErr == '' &&
                this.error.rentMonthlyErr == '' &&
                this.error.sizeErr == '' &&
                this.error.nameErr == '' &&
                this.error.desErr == '' &&
                this.error.floorErr == '' &&
                this.error.moveInDateErr == '' &&
                this.error.cityCidErr == '' &&
                this.error.districtCidErr == '' &&
                this.error.roadStreetCidErr == '' &&
                this.error.houseTypeErr == '' &&
                this.error.buildingTypeErr == '' &&
                this.error.specialTypeErr == '' &&
                this.error.shortestPeriodErr == '' &&
                this.error.payByRentPayDayErr == '' &&
                this.error.rentPayDayErr == '' &&
                this.error.isWithLandlordErr == ''

            ){
                return true
            }else{
                this.$store.dispatch('setAlarmStatus', {status: true,title: '請確認所有必填欄位都已填寫完畢',type: 'error'})
                return false
            }
        },
        isInRentInclude: function (itemName) {
            for (let i = 0; i < this.houseRentInclude.length; i++) {
                const element = this.houseRentInclude[i];
                if(element.check && element.itemName === itemName){
                    return true
                }
            }
        },
        closeAlart: function () {
            this.$store.commit('addHouse/set_save_success')
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
        },
        setFeaturesCount: function () {
            let features = this.insertHouse.featureList,
            count = 0
            features.forEach((item)=>{
                if(item.check){
                    count++
                }
            })
            this.featureListCount = count
        },
        removeBillCharge: function (itemName) {
            const list = this.insertHouse.billChargeMode
            for (let i = 0; i < list.length; i++) {
                const element = list[i];
                if(element.itemName === itemName){
                    this.insertHouse.billChargeMode.splice(i, 1)
                }
            }
        }
    },
    computed: {
        checkEquip: function () {
            const list = this.insertHouse.equipmentList
            let data = {
                itemName: null,
                isError: false
            }
            list.forEach((item, index) =>{
                if(item.check && !item.count){
                        data.isError = true
                        data.itemName = item.itemName
                        this.error.equipment[index] = true
                }else{
                    this.error.equipment[index] = false
                }
                this.componentKey++
            })
            return data
        },
        houseInclude:{
            get: function () {
                return // ...
            },
            set: function (val) {
                this.houseRentInclude.map( item => {
                    // console.log(val)
                    if( item.itemName == val.name ){
                        if( val.value == true ){
                            item.check = true
                        }else{
                            item.check = false
                        }
                    }
                });
            }
        },
        houseFeature:{
            get: function () {
                return // ...
            },
            set: function (val) {
                this.houseFeatures.map( item => {
                    if( item.itemName == val.name ){
                        if(val.value && this.featureListCount >= 6){
                            this.$store.dispatch('setAlarmStatus', {status: true,title: '特色標籤，最多選擇 6 個',type: 'error'})
                        }else{
                            if( val.value == true ){
                                item.check = true
                            }else{
                                item.check = false
                            }
                        }
                    }
                });
                this.setFeaturesCount()
            }
        },
        houseEquip:{
            get: function () {
                return // ...
            },
            set: function (val) {
                this.houseEquips.map( item => {
                    if( item.itemName == val.name ){
                        if( val.value == true ){
                            item.check = true
                        }else{
                            item.check = false
                        }
                    }
                });
            }
        },
        rulesInContract: function() {
            let arr = []
            let features = this.insertHouse.featureList

            for (let i = 0; i < features.length; i++) {
                const element = features[i];
                if(element.listInContract){
                    // arr[j] = element
                    if(element.listInContractWhen === 'FEATURE_NOT_SELECTED' && !element.check){
                        arr.push(element.listInContractName)
                    }else if(element.listInContractWhen === 'FEATURE_SELECTED' && element.check){
                        arr.push(element.listInContractName)
                    }
                }
            }
            return arr
        },
        housePolicyComputed:{
            get: function () {
                return // ...
            },
            set: function (val) {
                this.housePolicies.map( item => {
                    if( item.policySettingCid == val.id ){
                        if( val.value == true ){
                            this.insertHouse.editCaseHousePolicyDto.usePolicyDtoList.push({
                                "policySettingCid": item.policySettingCid,
                                "policyUsed": true
                            });
                        }else{
                            this.insertHouse.editCaseHousePolicyDto.usePolicyDtoList.map( (item, index) => {
                                if( item.policySettingCid == val.id){
                                    this.insertHouse.editCaseHousePolicyDto.usePolicyDtoList.splice( index, 1 )
                                }
                            })
                        }
                        
                    }
                });
            }
        },
        despositPolicyComputed:{
            get: function () {
                return // ...
            },
            set: function (val) {
                this.despositPolicies.map( item => {
                    if( item.policySettingCid == val.id ){
                        if( val.value == true ){
                            this.insertHouse.editCaseDepositPolicyDto.usePolicyDtoList.push({
                                "policySettingCid": item.policySettingCid,
                                "policyUsed": true
                            });
                        }else{
                            this.insertHouse.editCaseDepositPolicyDto.usePolicyDtoList.map( (item, index) => {
                                if( item.policySettingCid == val.id){
                                    this.insertHouse.editCaseDepositPolicyDto.usePolicyDtoList.splice( index, 1 )
                                }
                            })
                        }
                        
                    }
                });
            }
        },
        filterRoad: function () {
            return this.roads.filter((road) => {
                // console.log(road.roadStreetName)
                if( this.selectRoad ){
                    if(road.roadStreetName.includes(this.selectRoad)){
                        return road
                    }
                }else{
                    return road
                }
            });
        },
        ...mapGetters({
            houseEquips: 'GET_EQUIPS',
            houseFeatures: 'GET_FEATURES',
            houseRentInclude: 'GET_RENT_INCLUDE',
            buildingType: 'GET_BUILDING_TYPE',
            houseType: 'GET_HOUSE_TYPE',
            specialType: 'GET_SPECIAL_TYPE',
            counties: 'COUNTY_RESULT',
            districts: 'DISTRICTS_RESULT',
            roads: 'ROAD_RESULT',
            housePolicies: 'GET_HOUSE_POLICY',
            despositPolicies: 'GET_DESPOSIT_POLICY',
            alart: 'GET_SAVE_STATE',
            hasImage: 'GET_HOUSE_HAS_IMAGE',
            hasCover: 'GET_HOUSE_HAS_COVER',
            userVerify: 'GET_USER_VERIFY_STATUS',
            userNickname: 'GET_USER_HAS_NICKNAME',
            houseConfig: 'GET_HOUSE_CONFIG'
        })
    },
    components: {
        DatePicker,
        RentSelect,
        RentCheckbox,
        HouseCheckbox,
        uploadImg,
        PolicyCheckbox,
        Modal,
        NewPolicy,
        AlartMsg,
        addNickName,
        uploadVideo,
        Checkbox,
        addEquips,
        billCharge,
        chooseContractVersion
    }
}
</script>
<style lang="scss">
    .add-house{
        span.error{
            right: 0;
            top: -27px;
            left: unset;
            bottom: unset;
        }
        .add-house-head{
            position: relative;
            margin-top: 22px;
            margin-bottom: 40px;
            .btn-group{
                position: absolute;
                display: flex;
                top: -8px;
                right: 17px;
                .save{
                    width: 104px;
                    margin-right: 16px;
                }
                .publish{
                    width: 118px;
                }
            }
            
        }
        .unit-title{
            display: flex;
            align-items: center;
            font-size: 20px;
            margin-bottom: 30px;
            color: #ff9275
        }
        .title-description{
            display: flex;
            align-items: center;
            padding-left: 16px;
            color: #676362;
            font-size: 14px;
            img{
                margin-right: 4px;
            }
        }
        .add-label{
            display: block;
            font-weight: 500;
            margin-bottom: 12px;
        }
        // input{
        //     margin-bottom: 30px;
        // }
        .rent-select{
            background: #fff;
        }
        .add-house-description,
        .add-house-type,
        .add-house-policy,
        .add-contract-version{
            margin-bottom: 60px;
        }
        .add-house-description{
            width: 1156px;
            >div{
                margin-bottom: 30px;
            }
            input{
                width: 1120px;
            }
            textarea{
                width: 1120px;
                // height: 61px;
                padding: 12px 16px;
            }
            .house-intro{
                min-height: 100px;
                .intro-container{
                    position: relative;
                    min-height: 84px;
                    textarea{
                        position: relative;
                        top: 0px;
                        left: 0px;
                        min-height: 84px;
                        height: 100%;
                        padding: 12px 476px 12px 16px;
                        // background: transparent;
                        outline: 0;
                        resize: none;
                        overflow: hidden;
                    }
                    .des-count{
                        position: absolute;
                        z-index: 2;
                        right: 46px;
                        bottom: 12px;
                        color: #c5c2c1;
                        .count{
                            color: #292625;
                        }
                    }
                    // .pre{
                    //     display: block;
                    //     visibility: hidden;
                    // }
                }
            }
           
        }
        .add-house-type{
            .section-one{
                display: flex;
                flex-wrap: wrap;
                width: 1056px;
                > div{
                    position: relative;
                    width: 424px;
                    margin-bottom: 30px;
                }
                > div:nth-child(odd){
                    margin-right: 208px;
                }
                .shortest-period span.error,
                .is-with-landlord span.error,
                .lease-type span.error,
                .house-special span.error,
                .house-type span.error{
                    right: 0;
                    top: 2px;
                    left: unset;
                    bottom: unset;
                }
                .house-size{
                    input{
                        width: 390px;
                    }
                }
                .house-pattern{
                    .house-pattern-wrap{
                        display: flex;
                        align-items: center;
                        .rent-select{
                            width: 97px;
                            margin-right: 12px;
                        }
                        .rent-select:last-child{
                            margin-right: 0px;
                        }
                        
                    }
                    .house-pattern-wrap2{
                        display: flex;
                        align-items: center;
                        .rent-select{
                            width: 169px;
                        }
                        .rent-select:first-child{
                            margin-right: 12px;
                        }
                    }
                }
                .house-floor{
                    .house-floor-wrap{
                        display: flex;
                        align-items: center;
                        .rent-select{
                            width: 206px;
                            margin-right: 12px;
                        }
                    }
                }
                .house-total-floor{
                    input{
                        width: 390px;
                    }
                }
                .select-date{
                    position: absolute;
                    width: 98px;
                    top: 28px;
                    right: -142px;
                }
                .move-in-date{
                    .mx-datepicker{
                        width: 424px;
                        input{
                            height: 46px;
                            border-radius: 4px;
                            border: solid 1px #f3f3f3;
                            color: #a8a5a4;
                            padding: 13px 16px;
                            box-shadow: none;
                            margin-bottom: 0px;
                        }
                        .mx-icon-calendar,
                        .mx-icon-clear{
                            right: 14px;
                        }
                    }
                    .mx-datepicker.errorr{
                        input{
                            border: solid 1px #fc7171 !important;
                        }
                    }
                    .mx-datepicker:hover,
                    .mx-datepicker.active{
                        input{
                            border: 1px solid #676362;
                            color: #676362;
                        }
                        i{
                            color: #676362;
                        }
                    }
                }
            }
            .section-two{
                width: 1148px;
                .house-address{
                    position: relative;
                    margin-bottom: 14px;
                    display: flex;
                    flex-wrap: wrap;
                    span.error {
                        right: 52px;
                        top: 4px;
                        left: unset;
                        bottom: unset;
                    }
                    .hide-num{
                        position: relative;
                        top: -4px;
                        margin-left: 12px;
                    }
                    .house-address-wrap{
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        label{
                            margin-bottom: 0px;
                        }
                        > div{
                            margin-right: 12px;
                            margin-bottom: 16px;
                        }
                        > div:nth-child(-n+2){
                            width: 170px;
                        }
                        > div:nth-child(n+4){
                            color: #525956;
                            input{
                                width: 174px;
                                margin-bottom: 0px;
                            }
                        }
                        .select-road{
                            width: 174px;
                        }
                    }
                }
                .rent-include,
                .equipment,
                .rules{
                    margin-bottom: 30px;
                    .wrap{
                        display: flex;
                        flex-wrap: wrap;
                        > div{
                            margin-right: 12px;
                        }
                    }
                }
                .house-equips{
                    position: relative;
                    width: 424px;
                    margin-bottom: 16px !important;
                    justify-content: space-between;
                    &.odd{
                        margin-right: 208px !important;
                    }
                    &.new-equips{
                        border-radius: 4px;
                        border: solid 1px #e0dfde;
                        background-color: #ffffff;
                        height: 42px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                    }
                    .input-arear{
                        width: 310px;
                        >input{
                            width: 100%;
                            box-sizing: border-box;
                        }
                        .quantifier{
                            position: absolute;
                            right: 16px;
                            top: 12px;
                        }
                    }
                }
            }
        }
        .add-contract-version{
            .title-group{
                justify-content: space-between;
                .group{
                    display: flex;
                    align-items: center;
                    .refresh{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: relative;
                        border-radius: 4px;
                        background-color: #3942b5;
                        width: 134px;
                        height: 32px;
                        font-size: 14px;
                        color: #fff;
                        right: 29px;
                        cursor: pointer;
                        margin-bottom: 30px;
                        >img{
                            margin-right: 6px;
                        }
                    }
                }
            }
        }
        .add-house-policy{
            .house-policy{
                position: relative;
                margin-bottom: 60px;
                .group{
                    position: absolute;
                    display: flex;
                    top: -53px;
                    right: 22px;
                    >div{
                        a{
                            display: flex;
                            align-items: center;
                            >img{
                                margin-right: 4px;
                            }
                        }
                    }
                    .edit{
                        margin-right: 28px;
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        >img{
                            margin-right: 4px;
                        }
                    }
                }
            }
            .global-policy{
                .modal-content{
                    width: 1198px;
                    height: 760px;
                    padding: 0 32px !important;
                    .detail{
                        h1{
                            margin: 30px 0;
                        }
                        width: 1198px;
                        height: 760px;
                        overflow-x: hidden;
                    }
                    .detail::-webkit-scrollbar {
                        display: none;
                    }
                }
                
            }
        }
    }
    .add-house.fixed{
        .tool-bar-mask{
            position: fixed;
            width: 100%;
            background: #fff;
            height: 80px;
            top: 0px;
            z-index: 7;
            border-bottom: 1px solid #f0f0f0;
            margin-left: -39px;
        }
        .add-house-head{
            position: relative;
            margin-top: 22px;
            margin-bottom: 40px;
            h1{
                position: fixed;
                top: 26px;
            }
            .btn-group{
                position: fixed;
                top: 19px;
                right: unset;
                margin-left: 914px;
                .save{
                    width: 104px;
                    margin-right: 16px;
                }
                .publish{
                    width: 118px;
                }
            }
            
        }
    }
    @media screen and (max-width: 1280px) {
        .add-house{
            .add-house-description{
                width: 1142px;
                input,
                textarea
                {
                    width: 1108px;
                }
            }
        }
        .add-house.fixed{
          
            .add-house-head{
                .btn-group{
                    margin-left: 900px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/houseManagement/addHouse/AddHouseComp.vue